// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_null_undefined from "@rescript/std/lib/es6/js_null_undefined.js";

var defaultContent = {
  itemId: undefined,
  elementCodename: undefined,
  componentId: undefined
};

var context = React.createContext(defaultContent);

var provider = context.Provider;

function Kontent$Context$Provider(props) {
  var value_itemId = props.itemId;
  var value_elementCodename = props.elementCodename;
  var value_componentId = props.componentId;
  var value = {
    itemId: value_itemId,
    elementCodename: value_elementCodename,
    componentId: value_componentId
  };
  return React.createElement(provider, {
              value: value,
              children: props.children
            });
}

var Provider = {
  provider: provider,
  make: Kontent$Context$Provider
};

var Context = {
  defaultContent: defaultContent,
  context: context,
  Provider: Provider
};

function Kontent$Consumer(props) {
  var match = React.useContext(context);
  var attrs = {
    "data-kontent-item-id": Js_null_undefined.fromOption(match.itemId),
    "data-kontent-element-codename": Js_null_undefined.fromOption(match.elementCodename),
    "data-kontent-component-id": Js_null_undefined.fromOption(match.componentId)
  };
  return React.cloneElement(props.children, attrs);
}

var Consumer = {
  make: Kontent$Consumer
};

export {
  Context ,
  Consumer ,
}
/* context Not a pure module */
